import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import { Asset } from "@app/components/base-page/models";
import { DEFAULT_FADE_DURATION } from "@app/constants";

type Props = {
  image: Asset;
  className?: string;
};

export const Image: FC<Props> = ({ image, className }) => (
  <div className={className}>
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      <GatsbyImage
        image={getGatsbyImage(image.filename)}
        alt={image.alt}
        className="aspect-[13/16] w-full rounded-lg"
      />
    </Fade>
  </div>
);
